import { Enum } from 'enum-plus'

/** 显示/隐藏 */
export const IsHidden = Enum({
  Hidden: { value: 0, label: '隐藏' },
  Display: { value: 1, label: '显示' }
} as const)

/** 是否保活菜单 keepalive */
export const IsKeepalive = Enum({
  NO: { value: 0, label: '否' },
  YES: { value: 1, label: '是' }
} as const)

/** 是否新建标签页 */
export const IsBlank = Enum({
  NO: { value: 0, label: '否' },
  YES: { value: 1, label: '是' }
} as const)

/** 权限菜单类型 */
export const MenuType = Enum({
  Directory: { value: 1, label: '目录' },
  Menu: { value: 2, label: '菜单' },
  ButtonAndList: { value: 3, label: '按钮/列表' }
} as const)

/** 模式 */
export const Mode = Enum({
  add: { value: 'add', label: '新增' },
  update: { value: 'update', label: '编辑' }
} as const)

/** 启用状态（1 启用，2 未启用） */
export const Status = Enum({
	Enabled: { value: 1, label: '启用' },
	Disabled: { value: 2, label: '未启用' }
} as const)

/** 日产值提报状态（0 待提报，1 已提报） */
export const ProductionStatus = Enum({
	Pending: { value: 0, label: '待提报' },
	Reported: { value: 1, label: '已提报' }
} as const)
